/**
 * Friendly names for URL segments, shared by the breadcrumb and the browser
 * tab title. A page that knows the real name of what its URL points at (a
 * program slug like "wecare-home-health", a patient id) registers it here once
 * its data loads, so neither shows the slug title-cased ("Wecare Home Health")
 * or a raw id. Stored in sessionStorage under breadcrumb:<segment> (the key the
 * breadcrumb already read for ids); listeners re-render on the event below.
 */

export const ROUTE_LABEL_EVENT = 'arasync:route-label';

const keyFor = (segment) => `breadcrumb:${segment}`;

/** The registered name for a URL segment, or null. */
export function routeLabel(segment) {
  try {
    return (typeof window !== 'undefined' && window.sessionStorage?.getItem(keyFor(segment))) || null;
  } catch {
    // sessionStorage can throw in private mode or embedded contexts.
    return null;
  }
}

/** Register the real name for a URL segment and tell the breadcrumb and title. */
export function rememberRouteLabel(segment, label) {
  if (!segment || !label || routeLabel(segment) === label) return;
  try {
    window.sessionStorage?.setItem(keyFor(segment), label);
  } catch {
    // Without storage the name still applies through the event below.
  }
  try {
    window.dispatchEvent(new CustomEvent(ROUTE_LABEL_EVENT, { detail: { segment, label } }));
  } catch {
    // Old browsers without CustomEvent: the next navigation picks the name up.
  }
}
